// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dm-paginated-table-actions[data-v-30bcb3fd] {
  display: flex;
  justify-content: center;
}
.dm-paginated-table[data-v-30bcb3fd] {
  font-size: 16px;
}
[data-v-30bcb3fd] .table-sm th,[data-v-30bcb3fd] .table-sm td {
  vertical-align: middle !important;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
